import { render, staticRenderFns } from "./StatusTag.vue?vue&type=template&id=5f57606d&scoped=true&"
import script from "./StatusTag.vue?vue&type=script&lang=js&"
export * from "./StatusTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f57606d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/advtool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f57606d')) {
      api.createRecord('5f57606d', component.options)
    } else {
      api.reload('5f57606d', component.options)
    }
    module.hot.accept("./StatusTag.vue?vue&type=template&id=5f57606d&scoped=true&", function () {
      api.rerender('5f57606d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/StatusTag.vue"
export default component.exports